import React, { useEffect, useRef, useState } from 'react';
import { Nav } from 'react-bootstrap';
import * as Ui from './ScrollableTabs.styles';

const SCROLL_AMOUNT = 150;

const ScrollableTabs = ({
  tabs,
  activeTab,
  onTabChange,
  align = 'left',
  stretch = false,
  className,
}) => {
  const containerRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const updateScrollState = () => {
    const el = containerRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
  };

  const scrollLeft = () =>
    containerRef.current?.scrollBy({ left: -SCROLL_AMOUNT, behavior: 'smooth' });
  const scrollRight = () =>
    containerRef.current?.scrollBy({ left: SCROLL_AMOUNT, behavior: 'smooth' });

  useEffect(() => {
    updateScrollState();
    window.addEventListener('resize', updateScrollState);
    return () => window.removeEventListener('resize', updateScrollState);
  }, [tabs]);
  return (
    <Ui.Wrapper $align={align} $stretch={stretch} className={className}>
      <Nav ref={containerRef} onScroll={updateScrollState} activeKey={activeTab} variant="tabs">
        {tabs.map((tab) => (
          <Nav.Item key={tab.key}>
            <Nav.Link onClick={() => onTabChange(tab.key)} eventKey={tab.key}>
              {tab.label}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>

      {canScrollLeft && (
        <Ui.ScrollButtonLeft onClick={scrollLeft} aria-label="Scroll left">
          <Ui.ArrowIconLeft />
        </Ui.ScrollButtonLeft>
      )}

      {canScrollRight && (
        <Ui.ScrollButtonRight onClick={scrollRight} aria-label="Scroll right">
          <Ui.ArrowIconRight />
        </Ui.ScrollButtonRight>
      )}
    </Ui.Wrapper>
  );
};

export default ScrollableTabs;
